import checkPermission from '@/utils/checkPermission'

export default {
  inserted(el, binding) {
    checkButtonRoleList(el, binding)
  },
  update(el, binding) {
    if (binding.arg !== binding.oldArg || binding.value !== binding.oldValue) {
      checkButtonRoleList(el, binding)
    }
  },
}

async function checkButtonRoleList(el, binding) {
  const { value, arg } = binding
  const hasPermission = await checkPermission(arg, value)

  if (!hasPermission) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}
